import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.viewLogistic || initialState;

export const selectLogisticDetails = createSelector(
  [selectDomain],
  (state) => state.logisticDetails
);

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);
